import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next"
import {
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Grid,
  Alert,
  CircularProgress,
} from '@mui/material'
import { useCryptoNavigation, useAppNavigation } from '../../App'
import api from '../../services/api'

export default function HorseBreedForm() {
  const { t } = useTranslation()
  const { navigateToPage } = useCryptoNavigation()
  const { getParam } = useAppNavigation()
  
  const id = getParam('id')
  const mode = getParam('mode')
  const isEditMode = mode === 'edit' && Boolean(id)
  
  const [formData, setFormData] = useState({ horseBreedName: '' })
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [dataLoaded, setDataLoaded] = useState(false)

  // ✅ EVITA LOOPS INFINITOS
  useEffect(() => {
    if (isEditMode && id && !dataLoaded) {
      setLoading(true)
      
      api.get(`/horse_breed/${id}`)
        .then(response => {
          const data = response.data.breed || response.data
          setFormData({ horseBreedName: data.horseBreedName || '' })
          setDataLoaded(true)
        })
        .catch(err => {
          console.error('Erro ao carregar raça:', err)
          setError(t("horseBreeds.loadError"))
          setDataLoaded(true)
        })
        .finally(() => {
          setLoading(false)
        })
    } else if (!isEditMode) {
      setDataLoaded(true)
    }
  }, [isEditMode, id, dataLoaded])

  const handleSave = async () => {
    if (!formData.horseBreedName.trim()) {
      setError(t("horseBreeds.nameRequired"))
      return
    }

    setSaving(true)
    setError('')

    try {
      const dataToSend = { horseBreedName: formData.horseBreedName.trim() }

      if (isEditMode) {
        await api.put(`/horse_breed/${id}`, dataToSend)
      } else {
        await api.post('/horse_breed', dataToSend)
      }
      
      // ✅ NAVEGAÇÃO CORRETA
      navigateToPage('racas', { mode: 'list' })
    } catch (err) {
      setError(t("horseBreeds.saveError"))
    } finally {
      setSaving(false)
    }
  }

  const handleCancel = () => {
    navigateToPage('racas', { mode: 'list' })
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        {isEditMode ? 'Editar' : 'Nova'} Raça de Cavalo
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <TextField
        fullWidth
        label={t("horseBreeds.nameLabel")}
        value={formData.horseBreedName}
        onChange={(e) => {
          setFormData({ horseBreedName: e.target.value })
          if (error) setError('')
        }}
        required
        margin="normal"
        placeholder={t("horseBreeds.namePlaceholder")}
      />

      <Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button variant="outlined" onClick={handleCancel} disabled={saving}>
          Cancelar
        </Button>
        <Button 
          variant="contained" 
          onClick={handleSave} 
          disabled={saving || !formData.horseBreedName.trim()}
        >
          {saving ? 'Salvando...' : (isEditMode ? 'Atualizar' : 'Salvar')}
        </Button>
      </Box>
    </Paper>
  )
}
